import { useContext, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import isMobile from 'shared/util/is-mobile'
import { createGlobalStyle } from 'styled-components'
import { Container, Content, FlagContent, PortugueseFlag, SpanishFlag, SwitchButton, Text } from './style'
import { HeaderContext } from 'mobile/components/header/header'
import { useLocation } from 'react-router'
import { Experiment, Variant } from 'react-optimize'

const mobile = isMobile()

const GlobalStyle = createGlobalStyle`
  body {
    margin-top: 60px;
  }
`

const LocaleSwitch = () => {
    const location = useLocation()
    const { menu } = useContext(HeaderContext)
    const [switched, setSwitched] = useState<boolean>(false)
    const [notNow, setNotNow] = useState<boolean>(false)
    const { i18n } = useTranslation()

    const switchLang = (lng) => {
        googleAnalyticsEvent({
            category: 'translation',
            action: 'switch',
            label: lng,
        })
        i18n.changeLanguage(lng)
    }

    const lang = useMemo(() => {
        if (i18n?.language?.toLowerCase().includes('es')) {
            return 'es'
        }

        if (i18n?.language?.toLowerCase().includes('pt')) {
            return 'pt'
        }

        return 'en'
    }, [i18n])

    // Check lang
    if (lang === 'en') return <></>

    // Check if already closed
    if (notNow) return <></>

    // Check if menu is opened (mobile)
    if (menu === 'category') return <></>

    // Check if is git defailt page route
    if (location.pathname.split('/')[1] !== 'gifs') return <></>

    return (
        <Experiment id="V_dqIuT4S4ims-29Fo4leQ">
            <Variant id="1">
                <Container isMobile={mobile}>
                    {mobile && <GlobalStyle />}
                    <Content>
                        <FlagContent>
                            {lang === 'es' && (
                                <>
                                    <SpanishFlag />
                                    <Text
                                        onClick={() => {
                                            if (switched) {
                                                switchLang('es')
                                                setSwitched(false)
                                            }
                                        }}
                                    >
                                        {switched && 'Probar '}Español Beta
                                    </Text>
                                </>
                            )}
                            {lang === 'pt' && (
                                <>
                                    <PortugueseFlag />
                                    <Text
                                        onClick={() => {
                                            if (switched) {
                                                switchLang('pt')
                                                setSwitched(false)
                                            }
                                        }}
                                    >
                                        {switched && 'Tentar '}Português Beta
                                    </Text>
                                </>
                            )}
                        </FlagContent>

                        {mobile && (
                            <SwitchButton
                                onClick={() => {
                                    if (!switched) {
                                        switchLang('en')
                                    } else {
                                        setNotNow(true)
                                    }

                                    setSwitched(!switched)
                                }}
                            >
                                {switched ? 'Not now' : 'Browse in English'}
                            </SwitchButton>
                        )}
                    </Content>
                    {!mobile && (
                        <SwitchButton
                            onClick={() => {
                                if (!switched) {
                                    switchLang('en')
                                } else {
                                    setNotNow(true)
                                }

                                setSwitched(!switched)
                            }}
                        >
                            {switched ? 'Not now' : 'Browse in English'}
                        </SwitchButton>
                    )}
                </Container>
            </Variant>
        </Experiment>
    )
}

export default LocaleSwitch
